import { crmSystem } from "@/constants/crm/_shared/systems";

type Props = {
    selectedCrmSystem: crmSystem;
    components: Record<crmSystem, JSX.Element>;
}

const CrmComponentResolver = ({
    selectedCrmSystem,
    components,
}: Props) => {
    return components[selectedCrmSystem];
}

export {
    CrmComponentResolver,
}
